import React, {Component} from 'react';
import {Modal, ModalHeader} from 'reactstrap';
import {ReconnectAdAccountForm} from "./ReconnectAdAccountForm";
import {Translation} from 'react-i18next';

export class ReconnectAdAccountModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modal: false,
        };

        this.toggle = this.toggle.bind(this);
    }

    toggle() {
        if (this.props.onToggle) {
            this.props.onToggle();
        } else {
            this.setState({
                modal: !this.state.modal
            });
        }
    }

    isOpen() {
        if (this.props.isOpen !== undefined) {
            return this.props.isOpen;
        }
        return this.state.modal;
    }

    render() {
        const name = this.props.adAccountData && this.props.adAccountData.name;
        return (
            <Modal isOpen={this.isOpen()} toggle={this.toggle} className={this.props.className} backdrop="static">
                <ModalHeader toggle={this.toggle}>
                    <Translation>{(t) => t('reconnect_modal.title', { name })}</Translation>
                </ModalHeader>
                <ReconnectAdAccountForm
                    adAccountData={this.props.adAccountData}
                    onReconnected={this.props.onReconnected}
                    onToggle={this.toggle}
                />
            </Modal>
        );
    }
}
